module.exports = __webpack_public_path__ + "static/media/green-checkbox.d2899ed0.svg";